<script>import { stateTime } from "../state";
import { cfgBrandTitle } from "@infinitro/config";
import { Stage, stage } from "@infinitro/global";
import QRCode from "qrcode";
import { onDestroy, onMount } from "svelte";
import { TOTP } from "totp-generator";
const DEBUG = stage !== Stage.Prod;
const brand_title = cfgBrandTitle();
export let label = "";
export let secret;
let interval = void 0;
let qrCanvas;
const STEP = 30;
const QR_SIZE = 100;
function log(msg) {
  if (DEBUG) console.log(msg);
}
const sleep = (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));
let totp = {
  otp: "",
  expires: 0
};
const onCountdown = () => {
  const remaining = Math.ceil((totp.expires - Date.now()) / 1e3);
  if (remaining >= 1) stateTime.set(remaining);
  else {
    stateTime.set(STEP);
    totp = TOTP.generate(secret);
  }
};
onMount(async () => {
  if (!secret) {
    console.error("secret is required");
    return;
  }
  totp = TOTP.generate(secret);
  onCountdown();
  await sleep(Date.now() % 1e3);
  onCountdown();
  startTimer();
});
const getTotpSecret = () => {
  let uri = `otpauth://totp/${brand_title}:${label}?secret=${secret}`;
  console.log(`totp uri: ${uri}`);
  return uri;
};
const renderQr = async () => {
  if (!secret || !qrCanvas) return;
  try {
    await QRCode.toCanvas(qrCanvas, getTotpSecret(), { width: QR_SIZE, margin: 1 });
  } catch (err) {
    console.error("failed to render totp qr", err);
  }
};
$: if (secret && qrCanvas) renderQr();
const startTimer = () => {
  if (interval) clearInterval(interval);
  const remaining = Math.ceil((totp.expires - Date.now()) / 1e3);
  stateTime.set(remaining);
  interval = setInterval(onCountdown, 1e3);
};
let borderBottomWidth = "100%";
let borderRightHeight = "100%";
let borderTopWidth = "100%";
let borderLeftHeight = "100%";
$: stateTime.subscribe((value) => {
  const percentage = value / STEP * 100;
  if (percentage > 75) {
    borderBottomWidth = `${(percentage - 75) * 4}%`;
    borderRightHeight = "100%";
    borderTopWidth = "100%";
    borderLeftHeight = "100%";
  } else if (percentage > 50) {
    borderBottomWidth = "0%";
    borderRightHeight = `${(percentage - 50) * 4}%`;
    borderTopWidth = "100%";
    borderLeftHeight = "100%";
  } else if (percentage > 25) {
    borderBottomWidth = "0%";
    borderRightHeight = "0%";
    borderTopWidth = `${(percentage - 25) * 4}%`;
    borderLeftHeight = "100%";
  } else {
    borderBottomWidth = "0%";
    borderRightHeight = "0%";
    borderTopWidth = "0%";
    borderLeftHeight = `${percentage * 4}%`;
  }
});
onDestroy(() => {
  clearInterval(interval);
  log("totp_setup timer cleared");
});
</script>

{#if $stateTime > 0}
	<span class="timer-container">
		<span class="timer">
			<canvas bind:this={qrCanvas} width={QR_SIZE} height={QR_SIZE}></canvas>
		</span>
		<span class="timer-border timer-border-bottom" style="width: {borderBottomWidth}; right: 0;"
		></span>
		<span class="timer-border timer-border-right" style="height: {borderRightHeight}; top: 0;"
		></span>
		<span class="timer-border timer-border-top" style="width: {borderTopWidth}; left: 0;"></span>
		<span class="timer-border timer-border-left" style="height: {borderLeftHeight}; bottom: 0;"
		></span>
	</span>
{/if}

<style>
	.timer-container {
		position: relative;
		border-radius: 0.5rem;
		padding: 0.5rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		background-image: var(--gradient-main)
}
	.timer {
		z-index: 10;
		border-radius: 0.5rem;
		background-image: var(--gradient-main)
}
	.timer-border {
		position: absolute;
		border-radius: 0.5rem;
		background-color: var(--color-primary-500);
		transition:
			width 0.5s,
			height 0.5s
}

	.timer-border-bottom {
		bottom: 0px;
		height: 0.375rem
}

	.timer-border-right {
		right: 0px;
		width: 0.375rem
}

	.timer-border-top {
		top: 0px;
		height: 0.375rem
}

	.timer-border-left {
		left: 0px;
		width: 0.375rem
}
</style>
